import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { AlertService } from '../../../providers/alert-service';
import { TiposIrregularidadesService } from '../../../providers/tipos-irregularidades-service';

/*
  Generated class for the ModalTiposIrregularidades page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-tipos-irregularidades',
  templateUrl: 'modal-tipos-irregularidades.html',
  providers: [
    TiposIrregularidadesService
  ]
})
export class ModalTiposIrregularidadesPage {

  objetoCombo: any = [];
  objetoComboTipo: any;
  objeto: any;
  titulo: any;
  listaAssuntos: any;
  listaSubAssuntos: any;
  listaClassificacoes: any;
  listaLegislacao: any;
  listaModulos: any;
  lesgislacao: any;

  comboClassificacao: any = [];
  comboAssunto: any = [];
  comboSubAssunto: any = [];
  comboLegislacao: any = [];
  comboModulo: any = [];

  constructor(private viewCtrl: ViewController, public navParams: NavParams, public tiposIrregularidadesService: TiposIrregularidadesService, private alertService: AlertService) {
    this.carregarModal();
    this.titulo = this.navParams.get('param1');
    this.objeto = this.navParams.get('param2');
    this.populaModal();
  }

  templateCargaEmMassa() {
    this.tiposIrregularidadesService.downloadTemplateIrregularidadesMassa();
  }

  cargaEmMassa(event) {
    this.alertService.mostraModalConfirmacao("Salvar Irregularidades em Massa", "Você tem certeza que deseja salvar irregularidades em massa?",
      retornoModal => {
        if (retornoModal) {
          this.tiposIrregularidadesService.salvarEmMassa(event).subscribe(data => {
            this.alertService.mostraAlerta("Arquivo carregado.", "");
            this.objeto = data;
            console.log("objeto retornado da carga em massa");
            console.log(this.objetoCombo);
            this.carregarModal();
          }, error => {
            this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
            console.log("erro: " + error);
          });
        }
      }
    );
  }

  carregarModal() {
    this.listarAssuntos();
    this.listarSubAssuntos();
    this.listarClassificacoes();
    this.listarLegislacoes();
    this.listarModulos();
  }

  populaModal() {
    this.comboClassificacao = this.objeto.classificacao.codClassificacao + ' - ' + this.objeto.classificacao.dsClassificacao;
    this.comboAssunto = this.objeto.assunto.codAssunto + ' - ' + this.objeto.assunto.dsAssunto;

    if (this.objeto.subAssunto instanceof Array) {
      var lstSub = new Array();
      this.objeto.subAssunto.forEach(element => {
        lstSub.push(element.codSubAssunto + ' - ' + element.dsSubAssunto);
      });
      this.comboSubAssunto = lstSub;
    }

    if (this.objeto.legislacao instanceof Array) {
      var lstLeg = new Array();
      this.objeto.legislacao.forEach(element => {
        lstLeg.push(element.dsLegislacao);
      });
      this.comboLegislacao = lstLeg;
    }

    if (this.objeto.modulo instanceof Array) {
      var lstMod = new Array();
      this.objeto.modulo.forEach(element => {
        lstMod.push(element.dsModulo);
      });
      this.comboModulo = lstMod;
    }
  }

  listarAssuntos() {
    this.tiposIrregularidadesService.listarAssuntos().subscribe(data => this.listaAssuntos = data, error => console.log("erro: " + error));
  }

  listarSubAssuntos() {
    this.tiposIrregularidadesService.listarSubAssuntos().subscribe(data => this.listaSubAssuntos = data, error => console.log("erro: " + error));
  }

  listarClassificacoes() {
    this.tiposIrregularidadesService.listarClassificacoes().subscribe(data => this.listaClassificacoes = data, error => console.log("erro: " + error));
  }

  listarLegislacoes() {
    this.tiposIrregularidadesService.listarLegislacoes().subscribe(data => this.listaLegislacao = data, error => console.log("erro: " + error));
  }

  listarModulos() {
    this.tiposIrregularidadesService.listarModulos().subscribe(data => this.listaModulos = data, error => console.log("erro: " + error));
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  addClassificacao() {
    this.objetoComboTipo = "classificacao";
    this.objetoCombo = {
      titulo: "Adicionar Classificação",
      codigo: "",
      descricao: ""
    };
  }

  addAssunto() {
    this.objetoComboTipo = "assunto";
    this.objetoCombo = {
      titulo: "Adicionar Assunto",
      codigo: "",
      descricao: ""
    };
  }

  addSubAssunto() {
    this.objetoComboTipo = "subassunto";
    this.objetoCombo = {
      titulo: "Adicionar Sub Assunto",
      codigo: "",
      descricao: ""
    };
  }

  addLegislacao() {
    this.objetoComboTipo = "legislacao";
    this.objetoCombo = {
      titulo: "Adicionar Legislação",
      descricao: "",
    };
  }

  verifica() {
    let verifica = true;

    if (this.objetoCombo.codigo != "" && this.objetoCombo.descricao != "") {
      verifica = false;
    }

    return verifica;
  }

  onClassificacaoChange(novoValor) {
    let obj = novoValor.split(/ - (.+)/);
    this.objeto.classificacao = this.listaClassificacoes.filter((item) => obj[1] == item.dsClassificacao)[0];
  }

  onAssuntoChange(novoValor) {
    let obj = novoValor.split(/ - (.+)/);
    this.objeto.assunto = this.listaAssuntos.filter((item) => obj[1] == item.dsAssunto)[0];
  }

  onSubAssuntoChange(novoValor) {
    var array = new Array();
    novoValor.forEach(element => {
      let obj = element.split(/ - (.+)/);
      array.push(this.listaSubAssuntos.filter((item) => obj[1] == item.dsSubAssunto)[0])
    });
    this.objeto.subAssunto = array;
  }

  onLegislacaoChange(novoValor) {
    var array = new Array();
    novoValor.forEach(element => {
      array.push(this.listaLegislacao.filter((item) => element == item.dsLegislacao)[0]);
    });
    this.objeto.legislacao = array;
  }

  onModuloChange(novoValor) {
    var array = new Array();
    novoValor.forEach(element => {
      let modulo = this.listaModulos.filter((item) => element == item.dsModulo)[0];

      let moduloAux = {
        "idModulo": 0
      };

      moduloAux.idModulo = modulo.idModulo;

      array.push(moduloAux);
    });
    this.objeto.modulo = array;
  }

  checarPrenchimentoObrigatorio() {
    console.log(this.objeto);
    if (!this.objeto.classificacao || !this.objeto.assunto || !(this.objeto.subAssunto instanceof Array) || !(this.objeto.legislacao instanceof Array) ||
      !(this.objeto.modulo instanceof Array) || !this.objeto.nomeIrregularidade || !this.objeto.dsIrregularidade) {
      this.alertService.mostraAlerta("", "Por favor, preencher todos os campos obrigatórios: ");
      return false;
    }

    return true;
  }

  salvarIrregularidade() {
    if (this.checarPrenchimentoObrigatorio()) {
      this.tiposIrregularidadesService.salvarNovoTipoIrregularidade(this.objeto).subscribe(data => {
        this.alertService.mostraAlerta("", "Irregularidade salva com sucesso!");
        this.viewCtrl.dismiss();
      }, error => {
        console.log("erro: " + error);
        this.alertService.mostraAlerta("", "Houve um erro para salvar irregularidade.");
      });
    }
  }

  cancelarObjetoCombo() {
    this.objetoCombo = [];
    this.objetoComboTipo = null;
  }

  salvarObjetoCombo() {
    let jsonEnviar: any;
    switch (this.objetoComboTipo) {
      case "classificacao":
        jsonEnviar = {
          idClassificacao: 0,
          dsClassificacao: this.objetoCombo.descricao,
          codClassificacao: this.objetoCombo.codigo,
          flAtivo: true
        };

        this.tiposIrregularidadesService.salvarNovaClassificacao(jsonEnviar).subscribe(
          result => {
            if(result.mensagem === "Código já está sendo utilizado."){
              this.alertService.mostraAlerta("Aviso:", result.mensagem);
            } else {
              console.log("result: " + result);
              this.alertService.mostraAlerta("", result.mensagem);
              this.listarClassificacoes();
            }
          }, error => {
            console.log("erro: " + error);
            this.alertService.mostraAlerta("", "Houve um erro para salvar classificação.");
          }
        );
        break;
      case "assunto":
        jsonEnviar = {
          idAssunto: "",
          dsAssunto: this.objetoCombo.descricao,
          codAssunto: this.objetoCombo.codigo,
          flAtivo: true
        };

        this.tiposIrregularidadesService.salvarNovoAssunto(jsonEnviar).subscribe(
          result => {
            if(result.mensagem === "Código já está sendo utilizado."){
              this.alertService.mostraAlerta("Aviso:", result.mensagem);
            } else {
              console.log("result: " + result);
              this.alertService.mostraAlerta("", result.mensagem);
              this.listarAssuntos();
            }
        }, error => {
          console.log("erro: " + error);
          this.alertService.mostraAlerta("", "Houve um erro para salvar assunto.");
        });
        break;
      case "subassunto":
        jsonEnviar = {
          idSubAssunto: "",
          dsSubAssunto: this.objetoCombo.descricao,
          codSubAssunto: this.objetoCombo.codigo,
          flAtivo: true
        };

        this.tiposIrregularidadesService.salvarNovoSubAssunto(jsonEnviar).subscribe(
          result => {
            if(result.mensagem === "Código já está sendo utilizado."){
              this.alertService.mostraAlerta("Aviso:", result.mensagem);
            } else {
              console.log("result: " + result);
              this.alertService.mostraAlerta("", result.mensagem);
              this.listarSubAssuntos();
            }
        }, error => {
          console.log("erro: " + error);
          this.alertService.mostraAlerta("", "Houve um erro para salvar sub assunto.");
        });
        break;
      case "legislacao":
        jsonEnviar = {
          idLegislacao: "",
          dsLegislacao: this.objetoCombo.descricao,
          flAtivo: true
        };

        this.tiposIrregularidadesService.salvarNovaLegislacao(jsonEnviar).subscribe(data => {
          this.alertService.mostraAlerta("", "Legislação salva com sucesso!");
          this.listarLegislacoes();
        }, error => {
          console.log("erro: " + error);
          this.alertService.mostraAlerta("", "Houve um erro para salvar legislação.");
        });
        break;

      default:
        break;
    }
    this.cancelarObjetoCombo();
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-tipos-irregularidades/modal-tipos-irregularidades.ts